import * as React from 'react';
export const MovementRight = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z"
      fill="#EFEEF2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.272 7.333l8.395 4.834L8.272 17a12.592 12.592 0 000-9.667z"
      fill="#250F5A"
    />
  </svg>
);
